// 引入api请求方法
import base from '@/utils/base'
const state = {
    isLoginWindow:false,
    isCompany:false,
    isPwd:false,
    // 登录返回的信息
    loginData:{
        // 名字 ，用户名字
        name: "",
        // 所属公司列表
        companys: [],
        // 是否设置密码
        hasPassword: false,
        // 是否有万金油企业
        onlyWJY: false
    },
}

// getters
const getters = {}

// actions
const actions = {
    // 获取列表数据
    getList: async (context) => {
        
        try{
            let { data } = await getListStoredApply(context.state.postParams);
            data.list.forEach(item=>{
                item.amount = '¥'+fomatNumMoney(String(item.amount/100));
                item.statusText = storedApplyOptions.find(({value})=>value===item.status).label;
            })
            context.commit('updateListData', Object.assign({}, context.state.listData, data));
        }catch(err){
            base.$$message('获取汇款列表 失败：'+err,'error')
        }
    },
}

// mutations
const mutations = {
    // 更新data数据
    updateStateData (state, payload) {
        Object.assign(state,payload)
    },
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
